import { jsx as t, jsxs as v, Fragment as j } from "react/jsx-runtime";
import { AlertGroup as en, Alert as tn, AlertVariant as Le, AlertActionCloseButton as nn, Page as rn, Modal as Ct, ModalVariant as an, TextContent as ln, Text as Be, Button as V, Spinner as kt, FormHelperText as We, HelperText as je, HelperTextItem as Ge, Popover as on, Icon as Ne, FormGroup as It, NumberInput as sn, ValidatedOptions as K, InputGroup as we, InputGroupItem as Ve, TextInput as xe, Select as Se, SelectList as Te, SelectOption as ze, MenuToggle as pe, MenuToggleStatus as Je, TextInputGroup as wt, TextInputGroupMain as xt, ChipGroup as Ye, Chip as Qe, TextInputGroupUtilities as St, Switch as cn, TextArea as Tt, FileUpload as dn, Title as un, Card as hn, CardHeader as pn, CardTitle as mn, CardBody as fn, Grid as gn, GridItem as ot, PageSection as yn, JumpLinks as bn, JumpLinksItem as vn, ButtonVariant as ke, Checkbox as Cn, Radio as kn, MenuFooter as In, Dropdown as wn, DropdownList as xn, DropdownItem as st, Masthead as Sn, MastheadToggle as Tn, PageToggleButton as An, MastheadBrand as En, MastheadContent as Rn, Toolbar as Ce, ToolbarContent as _e, ToolbarItem as W, Avatar as Dn, Bullseye as On, EmptyState as Fn, EmptyStateIcon as ct, EmptyStateHeader as Pn, EmptyStateBody as Mn, EmptyStateFooter as Ln, EmptyStateActions as Bn, SearchInput as Nn, Divider as Vn, Pagination as _n, Badge as qn } from "@patternfly/react-core";
import { createContext as At, useContext as Et, useRef as J, useEffect as le, useCallback as he, useState as A, useMemo as q, forwardRef as Un, useId as Rt, Fragment as Dt, Children as Ot, Component as $n, isValidElement as Kn } from "react";
import { useTranslation as _ } from "react-i18next";
import { NetworkError as Ft } from "@keycloak/keycloak-admin-client";
import Hn from "keycloak-js";
import { ExclamationCircleIcon as Wn, HelpIcon as dt, EyeIcon as jn, EyeSlashIcon as Gn, TimesIcon as Pt, CubeIcon as zn, PaypalIcon as Jn, InstagramIcon as Yn, BitbucketIcon as Qn, MicrosoftIcon as Xn, TwitterIcon as Zn, StackOverflowIcon as er, OpenshiftIcon as tr, LinkedinIcon as nr, GoogleIcon as rr, GitlabIcon as ar, FacebookSquareIcon as lr, GithubIcon as ir, MinusCircleIcon as or, PlusCircleIcon as Mt, EllipsisVIcon as sr, BarsIcon as cr, SearchIcon as dr, SyncAltIcon as ur } from "@patternfly/react-icons";
import { useFormContext as Ae, Controller as ie, useController as Ee, FormProvider as hr, useWatch as pr } from "react-hook-form";
import { get as N, cloneDeep as mr, intersectionBy as fr } from "lodash-es";
import be from "@patternfly/react-styles/css/components/Avatar/avatar";
import { css as gr } from "@patternfly/react-styles";
import { Table as yr, TableVariant as br, Thead as vr, Tr as ve, Th as Pe, Tbody as ut, Td as re, ExpandableRowContent as Cr, ActionsColumn as kr, TableText as Ir } from "@patternfly/react-table";
import './main.css';function Xe(e, n) {
  const r = At(n);
  return r.displayName = e, r;
}
const wr = ["error", "errorMessage"], Me = "error_description";
function xr(e) {
  if (typeof e == "string")
    return e;
  if (e instanceof Ft)
    return Tr(e.responseData);
  if (e instanceof Error)
    return e.message;
  throw new Error("Unable to determine error message.");
}
function Sr(e) {
  if (!(e instanceof Ft))
    return;
  const n = e.responseData;
  return Lt(n);
}
function Lt(e) {
  if (typeof e == "object" && e !== null && Me in e && typeof e[Me] == "string")
    return e[Me];
}
function Tr(e) {
  if (!(typeof e != "object" || e === null))
    for (const n of wr) {
      const r = e[n];
      if (typeof r == "string")
        return r;
    }
}
const Ar = () => Math.floor(Math.random() * 1e3);
function Er(e) {
  return e != null;
}
function Ze(e) {
  const n = Et(e);
  if (Er(n))
    return n;
  throw new Error(
    `No provider found for ${e.displayName ? `the '${e.displayName}'` : "an unknown"} context, make sure it is included in your component hierarchy.`
  );
}
function Rr() {
  const e = J(!1), n = J(/* @__PURE__ */ new Set());
  le(() => (e.current = !1, () => {
    e.current = !0, r();
  }), []);
  function r() {
    n.current.forEach((a) => clearTimeout(a)), n.current.clear();
  }
  return he((a, l) => {
    if (e.current)
      throw new Error("Can't schedule a timeout on an unmounted component.");
    const i = Number(setTimeout(o, l));
    n.current.add(i);
    function o() {
      n.current.delete(i), a();
    }
    return function() {
      clearTimeout(i), n.current.delete(i);
    };
  }, []);
}
function Dr({ alerts: e, onCloseAlert: n }) {
  return /* @__PURE__ */ t(
    en,
    {
      "data-testid": "global-alerts",
      isToast: !0,
      style: { whiteSpace: "pre-wrap" },
      children: e.map(({ id: r, variant: a, message: l, description: i }, o) => /* @__PURE__ */ t(
        tn,
        {
          "data-testid": o === 0 ? "last-alert" : void 0,
          isLiveRegion: !0,
          variant: Le[a],
          component: "p",
          variantLabel: "",
          title: l,
          actionClose: /* @__PURE__ */ t(
            nn,
            {
              title: l,
              onClose: () => n(r)
            }
          ),
          children: i && /* @__PURE__ */ t("p", { children: i })
        },
        r
      ))
    }
  );
}
const Or = 8e3, Bt = Xe(
  "AlertContext",
  void 0
), _a = () => Ze(Bt), Fr = ({ children: e }) => {
  const { t: n } = _(), r = Rr(), [a, l] = A([]), i = (d) => l((u) => u.filter((c) => c.id !== d)), o = he(
    (d, u = Le.success, c) => {
      const y = {
        id: Ar(),
        message: d,
        variant: u,
        description: c
      };
      l((g) => [y, ...g]), r(() => i(y.id), Or);
    },
    [r]
  ), s = he(
    (d, u) => {
      const c = n(d, { error: xr(u) }), y = Sr(u);
      o(c, Le.danger, y);
    },
    [o, n]
  ), h = q(() => ({ addAlert: o, addError: s }), [o, s]);
  return /* @__PURE__ */ v(Bt.Provider, { value: h, children: [
    /* @__PURE__ */ t(Dr, { alerts: a, onCloseAlert: i }),
    e
  ] });
}, Pr = (e) => {
  const { t: n } = _(), r = e.error, a = Mr(r) || Lt(r)?.replace(/\+/g, " ");
  console.error(r);
  function l() {
    location.href = location.origin + location.pathname;
  }
  return /* @__PURE__ */ t(rn, { children: /* @__PURE__ */ t(
    Ct,
    {
      variant: an.small,
      title: a ? "" : n("somethingWentWrong"),
      titleIconVariant: "danger",
      showClose: !1,
      isOpen: !0,
      actions: [
        /* @__PURE__ */ t(V, { variant: "primary", onClick: l, children: n("tryAgain") }, "tryAgain")
      ],
      children: /* @__PURE__ */ t(ln, { children: a ? /* @__PURE__ */ t(Be, { children: n(a) }) : /* @__PURE__ */ t(Be, { children: n("somethingWentWrongDescription") }) })
    }
  ) });
};
function Mr(e) {
  return typeof e == "string" ? e : e instanceof Error ? e.message : null;
}
function Lr(e, n, r) {
  const [a, l] = A(
    () => e.getItem(n) ?? r
  ), i = he((o) => {
    l(o), e.setItem(n, o);
  }, []);
  return le(() => {
    l(e.getItem(n) ?? r), window.addEventListener("storage", o);
    function o(s) {
      s.storageArea === e && (s.key === null || s.key === n) && l(s.newValue ?? r);
    }
    return () => window.removeEventListener("storage", o);
  }, [e, n]), [a, i];
}
function Nt(e, n, r) {
  const a = q(
    () => JSON.stringify(r),
    [r]
  ), [l, i] = Lr(
    e,
    n,
    a
  ), o = q(() => JSON.parse(l), [l]), s = he(
    (h) => i(JSON.stringify(h)),
    []
  );
  return [o, s];
}
const Vt = Xe(
  "HelpContext",
  void 0
), Br = () => Ze(Vt), Nr = ({ children: e }) => {
  const [n, r] = Nt(localStorage, "helpEnabled", !0);
  function a() {
    r(!n);
  }
  return /* @__PURE__ */ t(Vt.Provider, { value: { enabled: n, toggleHelp: a }, children: e });
}, Vr = () => At(void 0);
let qe;
const qa = () => {
  const e = Et(qe);
  if (!e)
    throw Error(
      "no environment provider in the hierarchy make sure to add the provider"
    );
  return e;
}, Ua = ({
  environment: e,
  children: n
}) => {
  qe = Vr();
  const r = J(!1), [a, l] = A(!1), [i, o] = A(), s = q(() => {
    const d = new Hn({
      url: e.serverBaseUrl,
      realm: e.realm,
      clientId: e.clientId
    });
    return d.onAuthLogout = () => d.login(), d;
  }, [e]);
  le(() => {
    if (r.current)
      return;
    s.init({
      onLoad: "check-sso",
      pkceMethod: "S256",
      responseMode: "query",
      scope: e.scope
    }).then(() => l(!0)).catch((u) => o(u)), r.current = !0;
  }, [s]);
  const h = new URLSearchParams(window.location.search);
  return i || h.get("error_description") ? /* @__PURE__ */ t(
    Pr,
    {
      error: i || h.get("error_description")
    }
  ) : a ? /* @__PURE__ */ t(qe.Provider, { value: { environment: e, keycloak: s }, children: /* @__PURE__ */ t(Fr, { children: /* @__PURE__ */ t(Nr, { children: n }) }) }) : /* @__PURE__ */ t(kt, {});
};
function $a() {
  const n = document.getElementById("environment")?.textContent;
  if (typeof n != "string")
    throw new Error("Environment variables not found in the document.");
  try {
    return JSON.parse(n);
  } catch {
    throw new Error("Unable to parse environment variables as JSON.");
  }
}
const Ka = ({
  modalTitle: e,
  continueLabel: n,
  cancelLabel: r,
  buttonTitle: a,
  isDisabled: l,
  buttonVariant: i,
  buttonTestRole: o,
  onContinue: s,
  component: h = V,
  children: d,
  ...u
}) => {
  const [c, y] = A(!1);
  return /* @__PURE__ */ v(j, { children: [
    /* @__PURE__ */ t(
      h,
      {
        variant: i,
        onClick: () => y(!0),
        isDisabled: l,
        "data-testrole": o,
        children: a
      }
    ),
    /* @__PURE__ */ t(
      Ct,
      {
        variant: "small",
        ...u,
        title: e,
        isOpen: c,
        onClose: () => y(!1),
        actions: [
          /* @__PURE__ */ t(
            V,
            {
              id: "modal-confirm",
              variant: "primary",
              onClick: () => {
                y(!1), s();
              },
              children: n
            },
            "confirm"
          ),
          /* @__PURE__ */ t(
            V,
            {
              id: "modal-cancel",
              variant: "secondary",
              onClick: () => y(!1),
              children: r
            },
            "cancel"
          )
        ],
        children: d
      }
    )
  ] });
}, _t = ({ message: e, ...n }) => /* @__PURE__ */ t(We, { ...n, children: /* @__PURE__ */ t(je, { children: /* @__PURE__ */ t(Ge, { icon: /* @__PURE__ */ t(Wn, {}), variant: "error", children: e }) }) }), qt = ({
  helpText: e,
  fieldLabelId: n,
  noVerticalAlign: r = !0,
  unWrap: a = !1
}) => {
  const { enabled: l } = Br();
  return l ? /* @__PURE__ */ t(on, { bodyContent: e, children: /* @__PURE__ */ v(j, { children: [
    !a && /* @__PURE__ */ t(
      "button",
      {
        "data-testid": `help-label-${n}`,
        "aria-label": n,
        onClick: (i) => i.preventDefault(),
        className: "pf-v5-c-form__group-label-help",
        children: /* @__PURE__ */ t(Ne, { isInline: r, children: /* @__PURE__ */ t(dt, {}) })
      }
    ),
    a && /* @__PURE__ */ t(Ne, { isInline: r, children: /* @__PURE__ */ t(dt, {}) })
  ] }) }) : null;
};
function oe(e) {
  if (!(typeof e > "u" || e instanceof RegExp))
    return typeof e == "object" ? e.value : e;
}
const Y = ({
  id: e,
  name: n,
  label: r,
  labelIcon: a,
  error: l,
  children: i,
  ...o
}) => /* @__PURE__ */ v(
  It,
  {
    label: r || n,
    fieldId: e || n,
    labelIcon: a ? /* @__PURE__ */ t(qt, { helpText: a, fieldLabelId: e || n }) : void 0,
    ...o,
    children: [
      i,
      l && /* @__PURE__ */ t(_t, { "data-testid": `${n}-helper`, message: l.message })
    ]
  }
), Ha = ({
  name: e,
  label: n,
  controller: r,
  labelIcon: a,
  ...l
}) => {
  const {
    control: i,
    formState: { errors: o }
  } = Ae();
  return /* @__PURE__ */ t(
    Y,
    {
      name: e,
      label: n,
      isRequired: r.rules?.required === !0,
      error: o[e],
      labelIcon: a,
      children: /* @__PURE__ */ t(
        ie,
        {
          ...r,
          name: e,
          control: i,
          render: ({ field: s }) => {
            const h = !!r.rules?.required, d = oe(r.rules?.min), u = s.value ?? r.defaultValue, c = (y) => s.onChange(
              d !== void 0 ? Math.max(y, Number(d)) : y
            );
            return /* @__PURE__ */ t(
              sn,
              {
                ...l,
                id: e,
                value: u,
                validated: o[e] ? K.error : K.default,
                required: h,
                min: Number(d),
                max: Number(r.rules?.max),
                onPlus: () => c(u + 1),
                onMinus: () => c(u - 1),
                onChange: (y) => {
                  const g = Number(y.currentTarget.value);
                  c(isNaN(g) ? r.defaultValue : g);
                }
              }
            );
          }
        }
      )
    }
  );
}, _r = ({
  hasReveal: e = !0,
  innerRef: n,
  ...r
}) => {
  const { t: a } = _(), [l, i] = A(!0);
  return /* @__PURE__ */ v(we, { children: [
    /* @__PURE__ */ t(Ve, { isFill: !0, children: /* @__PURE__ */ t(
      xe,
      {
        ...r,
        type: l ? "password" : "text",
        ref: n
      }
    ) }),
    e && /* @__PURE__ */ t(
      V,
      {
        variant: "control",
        "aria-label": a("showPassword"),
        onClick: () => i(!l),
        children: l ? /* @__PURE__ */ t(jn, {}) : /* @__PURE__ */ t(Gn, {})
      }
    )
  ] });
}, Ut = Un(
  (e, n) => /* @__PURE__ */ t(_r, { ...e, innerRef: n })
);
Ut.displayName = "PasswordInput";
const Wa = (e) => {
  const { labelIcon: n, ...r } = e, a = !!oe(e.rules?.required), l = e.defaultValue ?? "", { field: i, fieldState: o } = Ee({
    ...e,
    defaultValue: l
  });
  return /* @__PURE__ */ v(
    Y,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: a,
      error: o.error,
      children: [
        /* @__PURE__ */ t(
          Ut,
          {
            isRequired: a,
            id: e.name,
            "data-testid": e.name,
            validated: o.error ? K.error : K.default,
            isDisabled: e.isDisabled,
            ...r,
            ...i
          }
        ),
        e.helperText && /* @__PURE__ */ t(We, { children: /* @__PURE__ */ t(je, { children: /* @__PURE__ */ t(Ge, { children: e.helperText }) }) })
      ]
    }
  );
}, qr = ({
  id: e,
  name: n,
  label: r,
  options: a,
  selectedOptions: l = [],
  controller: i,
  labelIcon: o,
  isDisabled: s,
  onSelect: h,
  ...d
}) => {
  const {
    control: u,
    formState: { errors: c }
  } = Ae(), [y, g] = A(!1), C = oe(i.rules?.required) === !0;
  return /* @__PURE__ */ t(
    Y,
    {
      id: e,
      name: n,
      label: r,
      isRequired: C,
      error: N(c, n),
      labelIcon: o,
      children: /* @__PURE__ */ t(
        ie,
        {
          ...i,
          name: n,
          control: u,
          render: ({ field: { onChange: R, value: m } }) => /* @__PURE__ */ t(
            Se,
            {
              ...d,
              variant: "default",
              onClick: () => g(!y),
              onOpenChange: () => g(!1),
              selected: te(a) ? a.filter(
                (p) => Array.isArray(m) ? m.includes(p.key) : m === p.key
              ).map((p) => p.value) : m,
              toggle: (p) => /* @__PURE__ */ t(
                pe,
                {
                  id: e || n,
                  ref: p,
                  onClick: () => g(!y),
                  isExpanded: y,
                  isFullWidth: !0,
                  status: N(c, n) ? Je.danger : void 0,
                  "aria-label": r,
                  isDisabled: s,
                  children: te(a) ? a.find(
                    (S) => S.key === (Array.isArray(m) ? m[0] : m)
                  )?.value : m
                }
              ),
              onSelect: (p, S) => {
                const T = S?.toString(), I = Array.isArray(m) ? [T] : T;
                h ? h(I, R) : R(I), g(!1);
              },
              isOpen: y,
              children: /* @__PURE__ */ t(Te, { "data-testid": `select-${n}`, children: [...a, ...l].map((p) => /* @__PURE__ */ t(ze, { value: ae(p), children: et(p) ? p : p.value }, ae(p))) })
            }
          )
        }
      )
    }
  );
}, ee = (e) => et(e) ? e : e.value, Ur = ({
  id: e,
  name: n,
  label: r,
  options: a,
  selectedOptions: l = [],
  controller: i,
  labelIcon: o,
  placeholderText: s,
  onFilter: h,
  variant: d,
  ...u
}) => {
  const {
    control: c,
    formState: { errors: y }
  } = Ae(), [g, C] = A(!1), [R, m] = A(""), [p, S] = A(0), [T, I] = A([]), b = J(), x = oe(i.rules?.required) === !0, F = d === ue.typeaheadMulti, E = q(
    () => [
      ...a.filter(
        (f) => !l.map((k) => ee(k)).includes(ee(f))
      ),
      ...l
    ],
    [l, a]
  ), B = E.filter(
    (f) => ee(f).toLowerCase().startsWith(R.toLowerCase())
  ), H = (f, k) => {
    k.value.includes(f) ? (k.onChange(k.value.filter((D) => D !== f)), te(a) && I(
      T.filter((D) => D.key !== f)
    )) : (k.onChange([...k.value, f]), te(E) && I([
      ...T,
      E.find((D) => D.key === f)
    ]));
  }, M = (f, k) => {
    const D = B[p];
    switch (C(!0), f.key) {
      case "Enter": {
        f.preventDefault(), m(F ? "" : ee(D)), H(ae(D), k), C(!1), S(0);
        break;
      }
      case "Tab":
      case "Escape": {
        C(!1), k.onChange(void 0);
        break;
      }
      case "Backspace": {
        d === ue.typeahead && k.onChange("");
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        f.preventDefault();
        let O = 0;
        f.key === "ArrowUp" && (p === 0 ? O = a.length - 1 : O = p - 1), f.key === "ArrowDown" && (p === a.length - 1 ? O = 0 : O = p + 1), S(O);
        break;
      }
    }
  };
  return /* @__PURE__ */ t(
    Y,
    {
      id: e,
      name: n,
      label: r,
      isRequired: x,
      error: N(y, n),
      labelIcon: o,
      children: /* @__PURE__ */ t(
        ie,
        {
          ...i,
          name: n,
          control: c,
          render: ({ field: f }) => /* @__PURE__ */ t(
            Se,
            {
              ...u,
              onOpenChange: () => C(!1),
              selected: te(E) ? E.filter(
                (k) => Array.isArray(f.value) ? f.value.includes(k.key) : f.value === k.key
              ).map((k) => k.value) : f.value,
              shouldFocusFirstItemOnOpen: !1,
              toggle: (k) => /* @__PURE__ */ t(
                pe,
                {
                  ref: k,
                  id: e || n,
                  variant: "typeahead",
                  onClick: () => {
                    C(!g), b.current?.focus();
                  },
                  isExpanded: g,
                  isFullWidth: !0,
                  status: N(y, n) ? Je.danger : void 0,
                  children: /* @__PURE__ */ v(wt, { isPlain: !0, children: [
                    /* @__PURE__ */ t(
                      xt,
                      {
                        placeholder: s,
                        value: d === ue.typeahead && f.value ? te(E) ? E.find(
                          (D) => D.key === (Array.isArray(f.value) ? f.value[0] : f.value)
                        )?.value : f.value : R,
                        onClick: () => C(!g),
                        onChange: (D, O) => {
                          m(O), h?.(O);
                        },
                        onKeyDown: (D) => M(D, f),
                        autoComplete: "off",
                        innerRef: b,
                        role: "combobox",
                        isExpanded: g,
                        "aria-controls": "select-typeahead-listbox",
                        children: d === ue.typeaheadMulti && Array.isArray(f.value) && /* @__PURE__ */ t(Ye, { "aria-label": "Current selections", children: f.value.map(
                          (D, O) => /* @__PURE__ */ t(
                            Qe,
                            {
                              onClick: (se) => {
                                se.stopPropagation(), f.onChange(
                                  f.value.filter(
                                    (U) => U !== ae(D)
                                  )
                                );
                              },
                              children: te(E) ? [
                                ...E,
                                ...T
                              ].find((se) => D === se.key)?.value : ee(D)
                            },
                            O
                          )
                        ) })
                      }
                    ),
                    /* @__PURE__ */ t(St, { children: (!!R || f.value) && /* @__PURE__ */ t(
                      V,
                      {
                        variant: "plain",
                        onClick: () => {
                          m(""), f.onChange(F ? [] : ""), b?.current?.focus();
                        },
                        "aria-label": "Clear input value",
                        children: /* @__PURE__ */ t(Pt, { "aria-hidden": !0 })
                      }
                    ) })
                  ] })
                }
              ),
              onSelect: (k, D) => {
                k?.stopPropagation();
                const O = D?.toString();
                F && Array.isArray(f.value) ? (m(""), H(O || "", f)) : (f.onChange(Array.isArray(f.value) ? [O] : O), C(!1));
              },
              isOpen: g,
              children: /* @__PURE__ */ t(Te, { children: B.map((k, D) => /* @__PURE__ */ t(
                ze,
                {
                  value: ae(k),
                  isFocused: p === D,
                  isActive: f.value.includes(ee(k)),
                  children: ee(k)
                },
                ae(k)
              )) })
            }
          )
        }
      )
    }
  );
};
var ue = /* @__PURE__ */ ((e) => (e.single = "single", e.typeahead = "typeahead", e.typeaheadMulti = "typeaheadMulti", e))(ue || {});
const te = (e) => typeof e[0] != "string", et = (e) => typeof e == "string", ae = (e) => et(e) ? e : e.key, $r = ({
  variant: e = "single",
  ...n
}) => e === "single" ? /* @__PURE__ */ t(qr, { ...n }) : /* @__PURE__ */ t(Ur, { ...n, variant: e }), Ue = (e) => e?.includes("${"), $e = (e) => e.substring(2, e.length - 1), ne = (e, n, r, a) => {
  const l = n || r, i = Ue(l) ? $e(l) : l, o = a ? `${a}.${i}` : i;
  return e(o || "");
}, Ke = (e, n) => ne(e, n.displayName, n.name), Kr = ["username", "firstName", "lastName", "email"], $t = (e) => e && Kr.includes(e), Q = (e) => `${$t(e) ? "" : "attributes."}${e?.replaceAll(
  ".",
  "🍺"
)}`, ja = (e) => e.replaceAll(".", "🍺"), Hr = (e) => e.replaceAll("🍺", ".");
function Ga(e, n, r) {
  (e.responseData.errors !== void 0 ? e.responseData.errors : [e.responseData]).forEach((a) => {
    const l = Object.assign(
      {},
      a.params?.map((i) => Ue(i?.toString()) ? r($e(i)) : i)
    );
    n(Q(a.field), {
      message: r(
        Ue(a.errorMessage) ? $e(a.errorMessage) : a.errorMessage,
        {
          /* eslint-disable @typescript-eslint/no-misused-spread */
          ...l,
          defaultValue: a.errorMessage || a.field
        }
      ),
      type: "server"
    });
  });
}
function Re({
  required: e
}) {
  return e;
}
function za(e) {
  if (typeof e != "object" || e === null || !("responseData" in e))
    return !1;
  const { responseData: n } = e;
  return ht(n) ? !0 : typeof n != "object" || n === null || !("errors" in n) || !Array.isArray(n.errors) ? !1 : n.errors.every(ht);
}
function ht(e) {
  return !(typeof e != "object" || e === null || !("field" in e) || typeof e.field != "string" || !("errorMessage" in e) || typeof e.errorMessage != "string");
}
const Ja = ({
  labelOn: e,
  stringify: n,
  defaultValue: r,
  labelIcon: a,
  ...l
}) => {
  const o = r ?? (n ? "false" : !1), { control: s } = Ae();
  return /* @__PURE__ */ t(
    Y,
    {
      hasNoPaddingTop: !0,
      name: l.name,
      isRequired: l.rules?.required === !0,
      label: l.label,
      labelIcon: a,
      children: /* @__PURE__ */ t(
        ie,
        {
          control: s,
          name: l.name,
          defaultValue: o,
          render: ({ field: { onChange: h, value: d } }) => /* @__PURE__ */ t(
            cn,
            {
              ...l,
              id: l.name,
              "data-testid": Hr(l.name),
              label: e,
              isChecked: n ? d === "true" : d,
              onChange: (u, c) => {
                const y = n ? c.toString() : c;
                l.onChange?.(u, c), h(y);
              }
            }
          )
        }
      )
    }
  );
}, Ya = (e) => {
  const n = !!e.rules?.required, r = e.defaultValue ?? "", { field: a, fieldState: l } = Ee({
    ...e,
    defaultValue: r
  });
  return /* @__PURE__ */ t(
    Y,
    {
      isRequired: n,
      label: e.label,
      labelIcon: e.labelIcon,
      name: e.name,
      error: l.error,
      children: /* @__PURE__ */ t(
        Tt,
        {
          isRequired: n,
          id: e.name,
          "data-testid": e.name,
          validated: l.error ? K.error : K.default,
          isDisabled: e.isDisabled,
          ...e,
          ...a
        }
      )
    }
  );
}, Qa = (e) => {
  const { labelIcon: n, helperText: r, ...a } = e, l = !!oe(e.rules?.required), i = e.defaultValue ?? "", { field: o, fieldState: s } = Ee({
    ...e,
    defaultValue: i
  });
  return /* @__PURE__ */ v(
    Y,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: l,
      error: s.error,
      children: [
        /* @__PURE__ */ t(
          xe,
          {
            isRequired: l,
            id: e.name,
            "data-testid": e["data-testid"] || e.name,
            validated: s.error ? K.error : K.default,
            isDisabled: e.isDisabled,
            ...a,
            ...o
          }
        ),
        r && /* @__PURE__ */ t(We, { children: /* @__PURE__ */ t(je, { children: /* @__PURE__ */ t(Ge, { children: r }) }) })
      ]
    }
  );
}, Wr = Tt, Xa = (e) => {
  const { labelIcon: n, ...r } = e, a = !!oe(e.rules?.required), l = e.defaultValue ?? "", { t: i } = _(), [o, s] = A(""), { field: h, fieldState: d } = Ee({
    ...e,
    defaultValue: l
  });
  return /* @__PURE__ */ t(
    Y,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: a,
      error: d.error,
      children: /* @__PURE__ */ t(
        dn,
        {
          isRequired: a,
          "data-testid": e["data-testid"] || e.name,
          filename: o,
          browseButtonText: i("browse"),
          validated: d.error ? K.error : K.default,
          hideDefaultPreview: !0,
          isDisabled: e.isDisabled,
          type: "text",
          onFileInputChange: (u, c) => {
            h.onChange(c), s(c.name);
          },
          onClearClick: () => {
            h.onChange(null), s("");
          },
          ...r,
          ...h
        }
      )
    }
  );
}, Za = ({ icon: e }) => {
  const n = jr(e);
  return /* @__PURE__ */ t(Ne, { size: "lg", children: /* @__PURE__ */ t(n, { alt: e }) });
};
function jr(e) {
  switch (e) {
    case "github":
      return ir;
    case "facebook":
      return lr;
    case "gitlab":
      return ar;
    case "google":
      return rr;
    case "linkedin":
    case "linkedin-openid-connect":
      return nr;
    case "openshift-v4":
      return tr;
    case "stackoverflow":
      return er;
    case "twitter":
      return Zn;
    case "microsoft":
      return Xn;
    case "bitbucket":
      return Qn;
    case "instagram":
      return Yn;
    case "paypal":
      return Jn;
    default:
      return zn;
  }
}
const Gr = "_title_180i0_2", zr = {
  title: Gr
}, Kt = ({
  id: e,
  title: n,
  headingLevel: r = "h1",
  size: a = "xl",
  ...l
}) => /* @__PURE__ */ t(
  un,
  {
    headingLevel: r,
    size: a,
    className: zr.title,
    id: e,
    tabIndex: 0,
    ...l,
    children: n
  }
), Jr = ({
  title: e,
  children: n,
  scrollId: r,
  className: a
}) => {
  const l = Rt();
  return /* @__PURE__ */ v(hn, { id: l, className: a, isFlat: !0, children: [
    /* @__PURE__ */ t(pn, { className: "kc-form-panel__header", children: /* @__PURE__ */ t(mn, { tabIndex: 0, children: /* @__PURE__ */ t(Kt, { id: r, title: e }) }) }),
    /* @__PURE__ */ t(fn, { className: "kc-form-panel__body", children: n })
  ] });
}, Yr = (e) => {
  const { title: n, children: r, scrollId: a, ...l } = e;
  return /* @__PURE__ */ t("section", { ...l, style: { marginTop: "var(--pf-v5-global--spacer--lg)" }, children: /* @__PURE__ */ v(j, { children: [
    /* @__PURE__ */ t(Kt, { id: a, title: n }),
    r
  ] }) });
}, Qr = "_panel_1cdve_1", Xr = "_sticky_1cdve_5", pt = {
  panel: Qr,
  sticky: Xr
}, Zr = "kc-main-content-page-container", mt = (e) => e.replace(/\s+/g, "-"), ea = ({
  label: e,
  sections: n,
  borders: r = !1,
  ...a
}) => {
  const l = q(
    () => n.filter(({ isHidden: i }) => !i),
    [n]
  );
  return /* @__PURE__ */ v(gn, { hasGutter: !0, ...a, children: [
    /* @__PURE__ */ t(ot, { md: 8, sm: 12, children: l.map(({ title: i, panel: o }) => {
      const s = mt(i.toLowerCase());
      return /* @__PURE__ */ t(Dt, { children: r ? /* @__PURE__ */ t(
        Jr,
        {
          scrollId: s,
          title: i,
          className: pt.panel,
          children: o
        }
      ) : /* @__PURE__ */ t(Yr, { scrollId: s, title: i, children: o }) }, i);
    }) }),
    /* @__PURE__ */ t(ot, { md: 4, sm: 12, order: { default: "-1", md: "1" }, children: /* @__PURE__ */ t(yn, { className: pt.sticky, children: /* @__PURE__ */ t(
      bn,
      {
        isVertical: !0,
        scrollableSelector: `#${Zr}`,
        label: e,
        offset: 100,
        children: l.map(({ title: i }) => {
          const o = mt(i.toLowerCase());
          return /* @__PURE__ */ t(
            vn,
            {
              onClick: () => {
                const s = document.getElementById(o);
                s && s.scrollIntoView({
                  behavior: "smooth",
                  block: "start"
                });
              },
              "data-testid": `jump-link-${o}`,
              children: i
            },
            i
          );
        })
      }
    ) }) })
  ] });
}, ta = (e, n, r) => (e.isValid || r) && (e.isDirty || n) && !e.isLoading && !e.isValidating && !e.isSubmitting, el = ({
  formState: e,
  isDisabled: n = !1,
  allowInvalid: r = !1,
  allowNonDirty: a = !1,
  children: l,
  ...i
}) => /* @__PURE__ */ t(
  V,
  {
    variant: "primary",
    isDisabled: e && !ta(e, a, r) || n,
    ...i,
    type: "submit",
    children: l
  }
), na = (e) => {
  try {
    return new Intl.DisplayNames([e], { type: "language" }).of(e);
  } catch {
    return e;
  }
}, ra = ({
  t: e,
  form: n,
  supportedLocales: r,
  currentLocale: a
}) => {
  const l = q(
    () => r.map((i) => ({
      key: i,
      value: e(`locale_${i}`, na(i) ?? i)
    })).sort((i, o) => i.value.localeCompare(o.value, a)),
    [r, a, e]
  );
  return l.length ? /* @__PURE__ */ t(hr, { ...n, children: /* @__PURE__ */ t(
    $r,
    {
      "data-testid": "locale-select",
      name: "attributes.locale",
      label: e("selectALocale"),
      controller: { defaultValue: "" },
      options: [{ key: "", value: e("defaultLocale") }, ...l],
      variant: l.length >= 10 ? "typeahead" : "single"
    }
  ) }) : null;
}, me = ({
  t: e,
  form: n,
  attribute: r,
  renderer: a,
  children: l
}) => {
  const i = ne(
    e,
    r.annotations?.inputHelperTextBefore
  ), {
    formState: { errors: o }
  } = n, s = a?.(r), h = N(o, Q(r.name));
  return /* @__PURE__ */ v(
    It,
    {
      label: Ke(e, r) || "",
      fieldId: r.name,
      isRequired: Re(r),
      labelIcon: i ? /* @__PURE__ */ t(qt, { helpText: i, fieldLabelId: r.name }) : void 0,
      children: [
        s ? /* @__PURE__ */ v(we, { children: [
          l,
          s
        ] }) : l,
        h && /* @__PURE__ */ t(
          _t,
          {
            "data-testid": `${r.name}-helper`,
            message: h.message
          }
        )
      ]
    },
    r.name
  );
}, aa = ({
  t: e,
  form: n,
  attribute: r,
  renderer: a,
  ...l
}) => /* @__PURE__ */ t(me, { t: e, form: n, attribute: r, renderer: a, children: /* @__PURE__ */ t(
  la,
  {
    t: e,
    form: n,
    "aria-label": Ke(e, r),
    name: Q(r.name),
    addButtonLabel: e("addMultivaluedLabel", {
      fieldLabel: Ke(e, r)
    }),
    ...l
  }
) }), la = ({
  t: e,
  name: n,
  inputType: r,
  form: a,
  addButtonLabel: l,
  isDisabled: i = !1,
  defaultValue: o,
  id: s,
  ...h
}) => {
  const { register: d, setValue: u, control: c } = a, y = pr({
    name: n,
    control: c,
    defaultValue: o || ""
  }), g = q(() => Array.isArray(y) && y.length !== 0 ? y : o || [""], [y]), C = (T) => {
    p([...g.slice(0, T), ...g.slice(T + 1)]);
  }, R = () => {
    p([...g, ""]);
  }, m = (T, I) => {
    p([...g.slice(0, T), I, ...g.slice(T + 1)]);
  }, p = (T) => {
    const I = T.flatMap((b) => b);
    u(n, I, {
      shouldDirty: !0
    });
  }, S = r.startsWith("html") ? r.substring(6) : "text";
  return le(() => {
    d(n);
  }, [d]), /* @__PURE__ */ t("div", { id: s, children: g.map((T, I) => /* @__PURE__ */ v(Dt, { children: [
    /* @__PURE__ */ v(we, { children: [
      /* @__PURE__ */ t(Ve, { isFill: !0, children: /* @__PURE__ */ t(
        xe,
        {
          "data-testid": n + I,
          onChange: (b, x) => m(I, x),
          name: `${n}.${I}.value`,
          value: T,
          isDisabled: i,
          type: S,
          ...h
        }
      ) }),
      /* @__PURE__ */ t(Ve, { children: /* @__PURE__ */ t(
        V,
        {
          "data-testid": "remove" + I,
          variant: ke.link,
          onClick: () => C(I),
          tabIndex: -1,
          "aria-label": e("remove"),
          isDisabled: g.length === 1 || i,
          children: /* @__PURE__ */ t(or, {})
        }
      ) })
    ] }),
    I === g.length - 1 && /* @__PURE__ */ v(
      V,
      {
        variant: ke.link,
        onClick: R,
        tabIndex: -1,
        "aria-label": e("add"),
        "data-testid": "addValue",
        isDisabled: !T || i,
        children: [
          /* @__PURE__ */ t(Mt, {}),
          " ",
          e(l || "add")
        ]
      }
    )
  ] }, I)) });
}, ft = (e) => {
  const { form: n, inputType: r, attribute: a } = e, l = Re(a), i = r.startsWith("multiselect"), o = i ? Cn : kn, s = a.validators?.options?.options || [], h = a.annotations?.inputOptionLabels || {}, d = a.annotations?.inputOptionLabelsI18nPrefix;
  return /* @__PURE__ */ t(me, { ...e, children: /* @__PURE__ */ t(
    ie,
    {
      name: Q(a.name),
      control: n.control,
      defaultValue: "",
      render: ({ field: u }) => /* @__PURE__ */ t(j, { children: s.map((c) => /* @__PURE__ */ t(
        o,
        {
          id: c,
          "data-testid": c,
          label: ne(e.t, h[c], c, d),
          value: c,
          isChecked: u.value.includes(c),
          onChange: () => {
            i ? u.value.includes(c) ? u.onChange(
              u.value.filter((y) => y !== c)
            ) : u.onChange([...u.value, c]) : u.onChange([c]);
          },
          readOnly: a.readOnly,
          isRequired: l
        },
        c
      )) })
    }
  ) });
}, ia = ({
  toggleId: e,
  onToggle: n,
  onSelect: r,
  selections: a,
  isOpen: l,
  menuAppendTo: i,
  direction: o,
  width: s,
  maxHeight: h,
  toggleIcon: d,
  className: u,
  isDisabled: c,
  children: y,
  ...g
}) => {
  const [C, R] = A(!1), m = J(), p = () => {
    R(!C), n(!C);
  }, S = () => i === "parent" && m.current?.parentElement || "inline", T = Ot.toArray(
    y
  );
  return /* @__PURE__ */ t(
    Se,
    {
      ref: m,
      maxMenuHeight: Ie(h),
      isScrollable: !0,
      popperProps: {
        appendTo: S(),
        direction: o,
        width: Ie(s)
      },
      ...g,
      onClick: p,
      onOpenChange: (I) => {
        I !== C && p();
      },
      selected: a,
      onSelect: (I, b) => {
        r?.(b || ""), p();
      },
      toggle: (I) => /* @__PURE__ */ t(
        pe,
        {
          id: e,
          ref: I,
          className: u,
          onClick: p,
          isExpanded: l,
          "aria-label": g["aria-label"],
          icon: d,
          isDisabled: c,
          isFullWidth: !0,
          children: T.find((b) => b.props.value === a)?.props.children || a || g["aria-label"]
        }
      ),
      isOpen: l,
      children: /* @__PURE__ */ t(Te, { children: y })
    }
  );
}, oa = ({
  toggleId: e,
  onSelect: n,
  onToggle: r,
  onFilter: a,
  variant: l,
  validated: i,
  placeholderText: o,
  maxHeight: s,
  width: h,
  toggleIcon: d,
  direction: u,
  selections: c,
  typeAheadAriaLabel: y,
  chipGroupComponent: g,
  chipGroupProps: C,
  footer: R,
  isDisabled: m,
  children: p,
  ...S
}) => {
  const [T, I] = A(""), [b, x] = A(0), F = J(), E = Ot.toArray(
    p
  ), B = () => {
    r?.(!S.isOpen);
  }, H = (M) => {
    const f = E[b];
    switch (r?.(!0), M.key) {
      case "Enter": {
        M.preventDefault(), l !== z.typeaheadMulti ? I(f.props.value) : I(""), n?.(f.props.value), r?.(!1), x(0);
        break;
      }
      case "Escape": {
        r?.(!1);
        break;
      }
      case "Backspace": {
        l === z.typeahead && n?.("");
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        M.preventDefault();
        let k = 0;
        M.key === "ArrowUp" && (b === 0 ? k = E.length - 1 : k = b - 1), M.key === "ArrowDown" && (b === E.length - 1 ? k = 0 : k = b + 1), x(k);
        break;
      }
    }
  };
  return /* @__PURE__ */ v(
    Se,
    {
      ...S,
      onClick: B,
      onOpenChange: (M) => r?.(M),
      onSelect: (M, f) => {
        n?.(f || ""), a?.(""), I("");
      },
      maxMenuHeight: Ie(s),
      popperProps: { direction: u, width: Ie(h) },
      toggle: (M) => /* @__PURE__ */ t(
        pe,
        {
          ref: M,
          id: e,
          variant: "typeahead",
          onClick: () => r?.(!0),
          icon: d,
          isDisabled: m,
          isExpanded: S.isOpen,
          isFullWidth: !0,
          status: i === "error" ? Je.danger : void 0,
          children: /* @__PURE__ */ v(wt, { isPlain: !0, children: [
            /* @__PURE__ */ t(
              xt,
              {
                placeholder: o,
                value: l === z.typeahead && c ? c : T,
                onClick: B,
                onChange: (f, k) => {
                  I(k), a?.(k);
                },
                onKeyDown: (f) => H(f),
                autoComplete: "off",
                innerRef: F,
                role: "combobox",
                isExpanded: S.isOpen,
                "aria-controls": "select-typeahead-listbox",
                "aria-label": y,
                children: l === z.typeaheadMulti && Array.isArray(c) && (g || /* @__PURE__ */ t(Ye, { ...C, children: c.map((f, k) => /* @__PURE__ */ t(
                  Qe,
                  {
                    onClick: (D) => {
                      D.stopPropagation(), n?.(f);
                    },
                    children: f
                  },
                  k
                )) }))
              }
            ),
            /* @__PURE__ */ t(St, { children: !!T && /* @__PURE__ */ t(
              V,
              {
                variant: "plain",
                onClick: () => {
                  n?.(""), I(""), a?.(""), F?.current?.focus();
                },
                "aria-label": "Clear input value",
                children: /* @__PURE__ */ t(Pt, { "aria-hidden": !0 })
              }
            ) })
          ] })
        }
      ),
      children: [
        /* @__PURE__ */ t(Te, { children: p }),
        R && /* @__PURE__ */ t(In, { children: R })
      ]
    }
  );
};
var z = /* @__PURE__ */ ((e) => (e.single = "single", e.typeahead = "typeahead", e.typeaheadMulti = "typeaheadMulti", e))(z || {});
const Ie = (e) => typeof e == "number" ? e + "px" : e, sa = ({
  variant: e = "single",
  ...n
}) => e === "single" ? /* @__PURE__ */ t(ia, { ...n }) : /* @__PURE__ */ t(oa, { ...n, variant: e }), gt = (e) => {
  const { t: n, form: r, inputType: a, attribute: l } = e, [i, o] = A(!1), [s, h] = A(""), d = a === "multiselect", u = (m, p) => {
    d ? p.value.includes(m) ? p.onChange(p.value.filter((S) => S !== m)) : Array.isArray(p.value) ? p.onChange([...p.value, m]) : p.onChange([m]) : p.onChange(m === p.value ? "" : m);
  }, c = l.validators?.options?.options || [], y = l.annotations?.inputOptionLabels || {}, g = l.annotations?.inputOptionLabelsI18nPrefix, C = (m) => ne(e.t, y[m], m, g), R = (m) => c.filter(
    (p) => C(p).toLowerCase().includes(s.toLowerCase())
  ).map((p) => /* @__PURE__ */ t(
    ze,
    {
      selected: m === p,
      value: p,
      children: C(p)
    },
    p
  ));
  return /* @__PURE__ */ t(me, { ...e, children: /* @__PURE__ */ t(
    ie,
    {
      name: Q(l.name),
      defaultValue: "",
      control: r.control,
      render: ({ field: m }) => /* @__PURE__ */ t(
        sa,
        {
          toggleId: l.name,
          onToggle: (p) => o(p),
          onClear: () => u("", m),
          onSelect: (p) => {
            const S = p.toString();
            u(S, m), Array.isArray(m.value) || o(!1);
          },
          selections: d && Array.isArray(m.value) ? m.value.map((p) => C(p)) : C(m.value),
          variant: d ? z.typeaheadMulti : c.length >= 10 ? z.typeahead : z.single,
          "aria-label": n("selectOne"),
          isOpen: i,
          isDisabled: l.readOnly,
          onFilter: (p) => (h(p), R(m.value)),
          children: R(m.value)
        }
      )
    }
  ) });
}, ca = (e) => {
  const { form: n, attribute: r } = e, a = Re(r);
  return /* @__PURE__ */ t(me, { ...e, children: /* @__PURE__ */ t(
    Wr,
    {
      id: r.name,
      "data-testid": r.name,
      ...n.register(Q(r.name)),
      cols: r.annotations?.inputTypeCols,
      rows: r.annotations?.inputTypeRows,
      readOnly: r.readOnly,
      isRequired: a
    }
  ) });
}, $ = (e) => {
  const { form: n, inputType: r, attribute: a } = e, l = Re(a), i = r.startsWith("html") ? r.substring(6) : "text";
  return /* @__PURE__ */ t(me, { ...e, children: /* @__PURE__ */ t(
    xe,
    {
      id: a.name,
      "data-testid": a.name,
      type: i,
      placeholder: a.readOnly ? "" : ne(
        e.t,
        a.annotations?.inputTypePlaceholder,
        "",
        a.annotations?.inputOptionLabelsI18nPrefix
      ),
      isDisabled: a.readOnly,
      isRequired: l,
      ...n.register(Q(a.name))
    }
  ) });
}, He = {
  text: $,
  textarea: ca,
  select: gt,
  "select-radiobuttons": ft,
  multiselect: gt,
  "multiselect-checkboxes": ft,
  "html5-email": $,
  "html5-tel": $,
  "html5-url": $,
  "html5-number": $,
  "html5-range": $,
  "html5-datetime-local": $,
  "html5-date": $,
  "html5-month": $,
  "html5-time": $,
  "multi-input": aa
}, tl = ({
  t: e,
  form: n,
  userProfileMetadata: r,
  supportedLocales: a,
  currentLocale: l,
  hideReadOnly: i = !1,
  renderer: o
}) => {
  const s = q(() => {
    if (!r.attributes)
      return [];
    const h = i ? r.attributes.filter(({ readOnly: d }) => !d) : r.attributes;
    return [
      // Insert an empty group for attributes without a group.
      { name: void 0 },
      ...r.groups ?? []
    ].map((d) => ({
      group: d,
      attributes: h.filter(
        (u) => u.group === d.name
      )
    }));
  }, [
    i,
    r.groups,
    r.attributes
  ]);
  return s.length === 0 ? null : /* @__PURE__ */ t(
    ea,
    {
      label: e("jumpToSection"),
      sections: s.filter((h) => h.attributes.length > 0).map(({ group: h, attributes: d }) => ({
        title: ne(e, h.displayHeader, h.name) || e("general"),
        panel: /* @__PURE__ */ v("div", { className: "pf-v5-c-form", children: [
          h.displayDescription && /* @__PURE__ */ t(Be, { className: "pf-v5-u-pb-lg", children: ne(e, h.displayDescription, "") }),
          d.map((u) => /* @__PURE__ */ t(
            da,
            {
              t: e,
              form: n,
              supportedLocales: a,
              currentLocale: l,
              renderer: o,
              attribute: u
            },
            u.name
          ))
        ] })
      }))
    }
  );
}, da = ({
  t: e,
  form: n,
  renderer: r,
  supportedLocales: a,
  currentLocale: l,
  attribute: i
}) => {
  const o = n.watch(
    Q(i.name)
  ), s = q(() => ha(i), [i]), h = i.multivalued || ma(o) && i.annotations?.inputType === void 0 ? He["multi-input"] : He[s];
  return i.name === "locale" ? /* @__PURE__ */ t(
    ra,
    {
      form: n,
      supportedLocales: a,
      currentLocale: l,
      t: e,
      attribute: i
    }
  ) : /* @__PURE__ */ t(
    h,
    {
      t: e,
      form: n,
      inputType: s,
      attribute: i,
      renderer: r
    }
  );
}, ua = "text";
function ha(e) {
  if ($t(e.name))
    return "text";
  const n = e.annotations?.inputType;
  return pa(n) ? n : ua;
}
const pa = (e) => typeof e == "string" && e in He, ma = (e) => Array.isArray(e) && e.length > 1, fa = ({
  className: e = "",
  border: n,
  size: r = "md"
}) => /* @__PURE__ */ v(
  "svg",
  {
    className: gr(
      be.avatar,
      be.modifiers[r],
      n === "light" && be.modifiers.light,
      n === "dark" && be.modifiers.dark,
      e
    ),
    enableBackground: "new 0 0 36 36",
    version: "1.1",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t(
        "circle",
        {
          style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
          cx: "18",
          cy: "18.5",
          r: "18"
        }
      ),
      /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t(
        "filter",
        {
          id: "b",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          filterUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ t("feColorMatrix", { values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" })
        }
      ) }),
      /* @__PURE__ */ t(
        "mask",
        {
          id: "a",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          maskUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ t("g", { style: { filter: 'url("#b")' }, children: /* @__PURE__ */ t(
            "circle",
            {
              style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
              cx: "18",
              cy: "18.5",
              r: "18"
            }
          ) })
        }
      ),
      /* @__PURE__ */ t("g", { style: { filter: 'url("#a")' }, children: /* @__PURE__ */ v("g", { transform: "translate(5.04 6.88)", children: [
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m22.6 18.1c-1.1-1.4-2.3-2.2-3.5-2.6s-1.8-0.6-6.3-0.6-6.1 0.7-6.1 0.7 0 0 0 0c-1.2 0.4-2.4 1.2-3.4 2.6-2.3 2.8-3.2 12.3-3.2 14.8 0 3.2 0.4 12.3 0.6 15.4 0 0-0.4 5.5 4 5.5l-0.3-6.3-0.4-3.5 0.2-0.9c0.9 0.4 3.6 1.2 8.6 1.2 5.3 0 8-0.9 8.8-1.3l0.2 1-0.2 3.6-0.3 6.3c3 0.1 3.7-3 3.8-4.4s0.6-12.6 0.6-16.5c0.1-2.6-0.8-12.1-3.1-15z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m22.5 26c-0.1-2.1-1.5-2.8-4.8-2.8l2.2 9.6s1.8-1.7 3-1.8c0 0-0.4-4.6-0.4-5z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m12.7 13.2c-3.5 0-6.4-2.9-6.4-6.4s2.9-6.4 6.4-6.4 6.4 2.9 6.4 6.4-2.8 6.4-6.4 6.4z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.08,
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#231F20"
            },
            d: "m9.4 6.8c0-3 2.1-5.5 4.9-6.3-0.5-0.1-1-0.2-1.6-0.2-3.5 0-6.4 2.9-6.4 6.4s2.9 6.4 6.4 6.4c0.6 0 1.1-0.1 1.6-0.2-2.8-0.6-4.9-3.1-4.9-6.1z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m8.3 22.4c-2 0.4-2.9 1.4-3.1 3.5l-0.6 18.6s1.7 0.7 3.6 0.9l0.1-23z"
          }
        )
      ] }) })
    ]
  }
), yt = ({
  isKebab: e = !1,
  title: n,
  dropDownItems: r,
  ...a
}) => {
  const [l, i] = A(!1);
  return /* @__PURE__ */ t(
    wn,
    {
      ...a,
      popperProps: {
        position: "right"
      },
      onOpenChange: (o) => i(o),
      toggle: (o) => /* @__PURE__ */ t(
        pe,
        {
          "data-testid": `${a["data-testid"]}-toggle`,
          ref: o,
          onClick: () => i(!l),
          isExpanded: l,
          variant: e ? "plain" : "default",
          children: e ? /* @__PURE__ */ t(sr, {}) : n
        }
      ),
      isOpen: l,
      children: /* @__PURE__ */ t(xn, { children: r })
    }
  );
};
function ga(e, n) {
  if (!e)
    return n("unknownUser");
  const r = e.given_name, a = e.family_name, l = e.preferred_username;
  return r && a ? n("fullName", { givenName: r, familyName: a }) : r || a || l || n("unknownUser");
}
const nl = ({
  keycloak: e,
  brand: { src: n, alt: r, className: a, ...l },
  avatar: i,
  features: {
    hasLogout: o = !0,
    hasManageAccount: s = !0,
    hasUsername: h = !0
  } = {},
  kebabDropdownItems: d,
  dropdownItems: u = [],
  toolbarItems: c,
  toolbar: y,
  ...g
}) => {
  const { t: C } = _(), R = [];
  s && R.push(
    /* @__PURE__ */ t(
      st,
      {
        onClick: () => e.accountManagement(),
        children: C("manageAccount")
      },
      "manageAccount"
    )
  ), o && R.push(
    /* @__PURE__ */ t(st, { onClick: () => e.logout(), children: C("signOut") }, "signOut")
  );
  const m = e.idTokenParsed?.picture;
  return /* @__PURE__ */ v(Sn, { ...g, children: [
    /* @__PURE__ */ t(Tn, { children: /* @__PURE__ */ t(An, { variant: "plain", "aria-label": C("navigation"), children: /* @__PURE__ */ t(cr, {}) }) }),
    /* @__PURE__ */ t(En, { ...l, children: /* @__PURE__ */ t("img", { src: n, alt: r, className: a }) }),
    /* @__PURE__ */ v(Rn, { children: [
      y,
      /* @__PURE__ */ t(Ce, { children: /* @__PURE__ */ v(_e, { children: [
        c?.map((p, S) => /* @__PURE__ */ t(W, { align: { default: "alignRight" }, children: p }, S)),
        /* @__PURE__ */ t(
          W,
          {
            visibility: {
              default: "hidden",
              md: "visible"
            },
            children: /* @__PURE__ */ t(
              yt,
              {
                "data-testid": "options",
                dropDownItems: [...u, R],
                title: h ? ga(e.idTokenParsed, C) : void 0
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          W,
          {
            align: { default: "alignLeft" },
            visibility: {
              md: "hidden"
            },
            children: /* @__PURE__ */ t(
              yt,
              {
                "data-testid": "options-kebab",
                isKebab: !0,
                dropDownItems: [
                  ...d || u,
                  R
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          W,
          {
            variant: "overflow-menu",
            align: { default: "alignRight" },
            className: "pf-v5-u-m-0-on-lg",
            children: m || i?.src ? /* @__PURE__ */ t(Dn, { src: m, alt: C("avatar"), ...i }) : /* @__PURE__ */ t(fa, { ...i })
          }
        )
      ] }) })
    ] })
  ] });
}, Ht = Xe("ErrorBoundaryContext", void 0), Wt = () => Ze(Ht);
class rl extends $n {
  state = {};
  static getDerivedStateFromError = (n) => ({ error: n });
  showBoundary = (n) => {
    this.setState({ error: n });
  };
  render() {
    return /* @__PURE__ */ t(
      Ht.Provider,
      {
        value: { error: this.state.error, showBoundary: this.showBoundary },
        children: this.props.children
      }
    );
  }
}
const al = ({ children: e, fallback: n }) => {
  const { error: r } = Wt();
  return r ? /* @__PURE__ */ t(n, { error: r }) : e;
};
function ya(e, n, r) {
  const { showBoundary: a } = Wt();
  le(() => {
    const l = new AbortController(), { signal: i } = l;
    return e().then((o) => {
      i.aborted || n(o);
    }).catch((o) => {
      console.error(o), i.aborted || a(o);
    }), () => l.abort();
  }, r);
}
const ba = () => {
  const { t: e } = _();
  return /* @__PURE__ */ t(On, { children: /* @__PURE__ */ t(kt, { "aria-label": e("spinnerLoading") }) });
}, va = ({
  message: e,
  instructions: n,
  onPrimaryAction: r,
  hasIcon: a = !0,
  isSearchVariant: l,
  primaryActionText: i,
  secondaryActions: o,
  icon: s,
  isDisabled: h = !1,
  children: d
}) => /* @__PURE__ */ v(Fn, { "data-testid": "empty-state", variant: "lg", children: [
  a && l ? /* @__PURE__ */ t(ct, { icon: dr }) : a && /* @__PURE__ */ t(ct, { icon: s || Mt }),
  /* @__PURE__ */ t(Pn, { titleText: e, headingLevel: "h1" }),
  /* @__PURE__ */ t(Mn, { children: n }),
  /* @__PURE__ */ v(Ln, { children: [
    i && /* @__PURE__ */ t(
      V,
      {
        "data-testid": `${e.replace(/\W+/g, "-").toLowerCase()}-empty-action`,
        variant: "primary",
        onClick: r,
        isDisabled: h,
        children: i
      }
    ),
    d,
    o && /* @__PURE__ */ t(Bn, { children: o.map((u) => /* @__PURE__ */ t(
      V,
      {
        "data-testid": `${u.text.replace(/\W+/g, "-").toLowerCase()}-empty-action`,
        variant: u.type || ke.secondary,
        onClick: u.onClick,
        isDisabled: h,
        children: u.text
      },
      u.text
    )) })
  ] })
] }), Ca = ({
  toolbarItem: e,
  subToolbar: n,
  toolbarItemFooter: r,
  children: a,
  searchTypeComponent: l,
  inputGroupName: i,
  inputGroupPlaceholder: o,
  inputGroupOnEnter: s
}) => {
  const { t: h } = _(), [d, u] = A(""), c = (g) => {
    u(g.trim()), s?.(g.trim());
  }, y = (g) => {
    g.key === "Enter" && c(d);
  };
  return /* @__PURE__ */ v(j, { children: [
    /* @__PURE__ */ t(Ce, { "data-testid": "table-toolbar", children: /* @__PURE__ */ v(_e, { children: [
      i && /* @__PURE__ */ t(W, { children: /* @__PURE__ */ v(we, { "data-testid": i, children: [
        l,
        o && /* @__PURE__ */ t(
          Nn,
          {
            "data-testid": "table-search-input",
            placeholder: o,
            "aria-label": h("search"),
            value: d,
            onChange: (g, C) => {
              u(C);
            },
            onSearch: () => c(d),
            onKeyDown: y,
            onClear: () => c("")
          }
        )
      ] }) }),
      e
    ] }) }),
    n && /* @__PURE__ */ t(Ce, { children: /* @__PURE__ */ t(_e, { children: n }) }),
    /* @__PURE__ */ t(Vn, {}),
    a,
    /* @__PURE__ */ t(Ce, { children: r })
  ] });
}, bt = ({
  id: e,
  variant: n = "top",
  count: r,
  first: a,
  max: l,
  onNextClick: i,
  onPreviousClick: o,
  onPerPageSelect: s
}) => {
  const { t: h } = _(), d = Math.round(a / l);
  return /* @__PURE__ */ t(
    _n,
    {
      widgetId: e,
      titles: {
        paginationAriaLabel: `${h("pagination")} ${n} `
      },
      isCompact: !0,
      toggleTemplate: ({
        firstIndex: u,
        lastIndex: c
      }) => /* @__PURE__ */ v("b", { children: [
        u,
        " - ",
        c
      ] }),
      itemCount: r + d * l,
      page: d + 1,
      perPage: l,
      onNextClick: (u, c) => i((c - 1) * l),
      onPreviousClick: (u, c) => o((c - 1) * l),
      onPerPageSelect: (u, c, y) => s(y - 1, c),
      variant: n
    }
  );
}, ka = ({
  count: e,
  searchTypeComponent: n,
  toolbarItem: r,
  subToolbar: a,
  children: l,
  inputGroupName: i,
  inputGroupPlaceholder: o,
  inputGroupOnEnter: s,
  ...h
}) => /* @__PURE__ */ t(
  Ca,
  {
    searchTypeComponent: n,
    toolbarItem: /* @__PURE__ */ v(j, { children: [
      r,
      /* @__PURE__ */ t(W, { variant: "pagination", children: /* @__PURE__ */ t(bt, { count: e, ...h }) })
    ] }),
    subToolbar: a,
    toolbarItemFooter: e !== 0 ? /* @__PURE__ */ t(W, { variant: "pagination", children: /* @__PURE__ */ t(bt, { count: e, variant: "bottom", ...h }) }) : null,
    inputGroupName: i,
    inputGroupPlaceholder: o,
    inputGroupOnEnter: s,
    children: l
  }
), jt = (e) => !!e && e.title !== void 0, vt = ({
  row: e,
  index: n,
  actions: r,
  actionResolver: a
}) => {
  const l = r || a?.(e, {});
  return /* @__PURE__ */ v(j, { children: [
    e.cells.map((i, o) => /* @__PURE__ */ t(re, { children: jt(i) ? i.title : i }, `cell-${o}`)),
    l && l.length > 0 && !e.disableActions && /* @__PURE__ */ t(re, { isActionCell: !0, children: /* @__PURE__ */ t(kr, { items: l, extraData: { rowIndex: n } }) })
  ] });
}, Ia = ({ row: e }) => e.cells.map((n, r) => /* @__PURE__ */ t("div", { children: jt(n) ? n.title : n }, `cell-${r}`));
function wa({
  columns: e,
  rows: n,
  actions: r,
  actionResolver: a,
  ariaLabelKey: l,
  selected: i,
  onSelect: o,
  onCollapse: s,
  canSelectAll: h,
  canSelect: d,
  isNotCompact: u,
  isRadio: c,
  ...y
}) {
  const { t: g } = _(), [C, R] = A(i || []), [m, p] = A([]), S = q(
    () => fr(
      C,
      n.map((b) => b.data),
      "id"
    ),
    [C, n]
  );
  le(() => {
    if (h) {
      const b = document.getElementsByName("check-all").item(0);
      if (b) {
        const x = b;
        x.indeterminate = S.length < n.length && S.length > 0;
      }
    }
  }, [C, h, n]);
  const T = (b) => {
    R(b), o?.(b);
  }, I = (b, x) => {
    if (c) {
      const F = x ? [n[b].data] : [];
      T(F);
    } else if (b === -1) {
      const F = S.map(
        (E) => N(E, "id")
      );
      T(
        x ? [...C, ...n.map((E) => E.data)] : C.filter(
          (E) => !F.includes(N(E, "id"))
        )
      );
    } else
      T(x ? [...C, n[b].data] : C.filter(
        (F) => N(F, "id") !== n[b].data.id
      ));
  };
  return /* @__PURE__ */ v(
    yr,
    {
      ...y,
      variant: u ? void 0 : br.compact,
      "aria-label": g(l),
      children: [
        /* @__PURE__ */ t(vr, { children: /* @__PURE__ */ v(ve, { children: [
          s && /* @__PURE__ */ t(Pe, { screenReaderText: g("expandRow") }),
          h && /* @__PURE__ */ t(
            Pe,
            {
              screenReaderText: g("selectAll"),
              select: c ? void 0 : {
                onSelect: (b, x) => {
                  I(-1, x);
                },
                isSelected: S.length === n.length
              }
            }
          ),
          e.map((b) => /* @__PURE__ */ t(
            Pe,
            {
              screenReaderText: g("expandRow"),
              className: b.transforms?.[0]().className,
              children: g(b.displayKey || b.name)
            },
            b.displayKey || b.name
          ))
        ] }) }),
        s ? n.map((b, x) => /* @__PURE__ */ t(ut, { children: x % 2 === 0 ? /* @__PURE__ */ v(ve, { children: [
          /* @__PURE__ */ t(
            re,
            {
              expand: n[x + 1].cells.length === 0 ? void 0 : {
                isExpanded: !!m[x],
                rowIndex: x,
                expandId: "expandable-row-",
                onToggle: (F, E, B) => {
                  s(B, E);
                  const H = [...m];
                  H[x] = B, p(H);
                }
              }
            }
          ),
          /* @__PURE__ */ t(
            vt,
            {
              row: b,
              index: x,
              actions: r,
              actionResolver: a
            }
          )
        ] }) : /* @__PURE__ */ v(ve, { isExpanded: !!m[x - 1], children: [
          /* @__PURE__ */ t(re, {}),
          /* @__PURE__ */ t(re, { colSpan: e.length, children: /* @__PURE__ */ t(Cr, { children: /* @__PURE__ */ t(Ia, { row: b }) }) })
        ] }) }, x)) : /* @__PURE__ */ t(ut, { children: n.map((b, x) => /* @__PURE__ */ v(ve, { isExpanded: m[x], children: [
          d && /* @__PURE__ */ t(
            re,
            {
              select: {
                rowIndex: x,
                onSelect: (F, E, B) => {
                  I(B, E);
                },
                isSelected: !!C.find(
                  (F) => N(F, "id") === b.data.id
                ),
                variant: c ? "radio" : "checkbox",
                isDisabled: b.disableSelection
              }
            }
          ),
          /* @__PURE__ */ t(
            vt,
            {
              row: b,
              index: x,
              actions: r,
              actionResolver: a
            }
          )
        ] }, x)) })
      ]
    }
  );
}
function xa({
  ariaLabelKey: e,
  searchPlaceholderKey: n,
  isPaginated: r = !1,
  onSelect: a,
  canSelectAll: l = !1,
  isNotCompact: i,
  isRadio: o,
  detailColumns: s,
  isRowDisabled: h,
  loader: d,
  columns: u,
  actions: c,
  actionResolver: y,
  searchTypeComponent: g,
  toolbarItem: C,
  subToolbar: R,
  emptyState: m,
  icon: p,
  isSearching: S = !1,
  ...T
}) {
  const { t: I } = _(), [b, x] = A([]), [F, E] = A(), [B, H] = A(), [M, f] = A(!1), [k, D] = Nt(
    localStorage,
    "pageSize",
    10
  ), [O, se] = A(k), [U, ce] = A(0), [G, De] = A(""), tt = J(), [fe, Gt] = A(0), nt = J(), rt = () => Gt(fe + 1), zt = Rt(), at = (w, P) => w.map((L) => {
    if ("cellFormatters" in L) {
      const Z = N(P, L.name);
      return L.cellFormatters?.reduce((de, ye) => ye(de), Z);
    }
    if (L.cellRenderer) {
      const Z = L.cellRenderer;
      return { title: /* @__PURE__ */ t(Z, { ...P }) };
    }
    return N(P, L.name);
  }), lt = (w) => {
    const P = (L) => s?.[0]?.enabled?.(L);
    return w.map((L, Z) => {
      const de = h ? h(L) : !1, ye = [
        {
          data: L,
          disableSelection: de,
          disableActions: de,
          selected: !!b.find((Zt) => N(Zt, "id") === N(L, "id")),
          isOpen: P(L) ? !1 : void 0,
          cells: at(u, L)
        }
      ];
      return s && ye.push({
        parent: Z * 2,
        cells: P(L) ? at(s, L) : []
      }), ye;
    }).flat();
  }, Oe = (w) => ["string", "number"].includes(typeof w) ? w.toString() : w instanceof Array ? w.map(Oe).join("") : typeof w == "object" ? Oe(
    Kn(w.title) ? w.title.props : Object.values(w)
  ) : "", it = q(
    () => G === "" || r ? void 0 : lt(B || []).filter(
      (w) => w.cells.some(
        (P) => P && Oe(P).toLowerCase().includes(G.toLowerCase())
      )
    ).slice(U, U + O + 1),
    [G, U, O]
  );
  ya(
    async () => {
      f(!0);
      const w = tt.current === "" && G !== "";
      return w && ce(0), tt.current = G, typeof d == "function" ? fe === nt.current && B ? B : await d(w ? 0 : U, O + 1, G) : d;
    },
    (w) => {
      nt.current = fe, r || (H(w), w.length > U ? w = w.slice(U, U + O + 1) : ce(0));
      const P = lt(w);
      E(P), f(!1);
    },
    [
      fe,
      U,
      O,
      G,
      typeof d != "function" ? d : void 0
    ]
  );
  const Jt = () => c && mr(c).map((w, P) => (delete w.onRowClick, w.onClick = async (L, Z) => {
    await c[P].onRowClick(
      (it || F)[Z].data
    ) && (r || De(""), rt());
  }, w)), Yt = (w, P) => {
    X[P].isOpen = w, E([...X]);
  }, X = it || F, ge = !X || X.length === 0, Fe = G !== "" || S, Qt = s ? O * 2 : O, Xt = s ? (X?.length || 0) / 2 : X?.length || 0;
  return /* @__PURE__ */ v(j, { children: [
    (!ge || Fe) && /* @__PURE__ */ v(
      ka,
      {
        id: zt,
        count: Xt,
        first: U,
        max: O,
        onNextClick: ce,
        onPreviousClick: ce,
        onPerPageSelect: (w, P) => {
          ce(w), se(P), D(P);
        },
        inputGroupName: n ? `${e}input` : void 0,
        inputGroupOnEnter: De,
        inputGroupPlaceholder: I(n || ""),
        searchTypeComponent: g,
        toolbarItem: /* @__PURE__ */ v(j, { children: [
          C,
          " ",
          /* @__PURE__ */ t(W, { variant: "separator" }),
          " ",
          /* @__PURE__ */ t(W, { children: /* @__PURE__ */ v(V, { variant: "link", onClick: rt, "data-testid": "refresh", children: [
            /* @__PURE__ */ t(ur, {}),
            " ",
            I("refresh")
          ] }) })
        ] }),
        subToolbar: R,
        children: [
          !M && !ge && /* @__PURE__ */ t(
            wa,
            {
              ...T,
              canSelectAll: l,
              canSelect: !!a,
              selected: b,
              onSelect: (w) => {
                x(w), a?.(w);
              },
              onCollapse: s ? Yt : void 0,
              actions: Jt(),
              actionResolver: y,
              rows: X.slice(0, Qt),
              columns: u,
              isNotCompact: i,
              isRadio: o,
              ariaLabelKey: e
            }
          ),
          !M && ge && Fe && /* @__PURE__ */ t(
            va,
            {
              hasIcon: !0,
              icon: p,
              isSearchVariant: !0,
              message: I("noSearchResults"),
              instructions: I("noSearchResultsInstructions"),
              secondaryActions: S ? [] : [
                {
                  text: I("clearAllFilters"),
                  onClick: () => De(""),
                  type: ke.link
                }
              ]
            }
          )
        ]
      }
    ),
    M && /* @__PURE__ */ t(ba, {}),
    !M && ge && !Fe && m
  ] });
}
const Sa = ({ link: e, organization: n }) => {
  const { t: r } = _();
  return /* @__PURE__ */ t(Ir, { wrapModifier: "truncate", children: /* @__PURE__ */ v(e, { organization: n, children: [
    n.name,
    !n.enabled && /* @__PURE__ */ t(
      qn,
      {
        isRead: !0,
        className: "pf-v5-u-ml-sm",
        children: r("disabled")
      },
      `${n.id}-disabled`
    )
  ] }) });
}, Ta = (e) => {
  const { t: n } = _();
  return /* @__PURE__ */ t(
    Ye,
    {
      numChips: 2,
      expandedText: n("hide"),
      collapsedText: n("showRemaining"),
      children: e.domains?.map((r) => {
        const a = typeof r == "string" ? r : r.name;
        return /* @__PURE__ */ t(Qe, { isReadOnly: !0, children: a }, a);
      })
    }
  );
}, ll = ({
  loader: e,
  toolbarItem: n,
  isPaginated: r = !1,
  isSearching: a = !1,
  searchPlaceholderKey: l,
  onSelect: i,
  onDelete: o,
  deleteLabel: s = "delete",
  link: h,
  children: d
}) => {
  const { t: u } = _();
  return /* @__PURE__ */ t(
    xa,
    {
      loader: e,
      isPaginated: r,
      isSearching: a,
      ariaLabelKey: "organizationList",
      searchPlaceholderKey: l,
      toolbarItem: n,
      onSelect: i,
      canSelectAll: i !== void 0,
      actions: o ? [
        {
          title: u(s),
          onRowClick: o
        }
      ] : void 0,
      columns: [
        {
          name: "name",
          displayKey: "name",
          cellRenderer: (c) => /* @__PURE__ */ t(Sa, { link: h, organization: c })
        },
        {
          name: "domains",
          displayKey: "domains",
          cellRenderer: Ta
        },
        {
          name: "description",
          displayKey: "description"
        },
        {
          name: "membershipType",
          displayKey: "membershipType"
        }
      ],
      emptyState: d
    }
  );
};
export {
  Fr as AlertProvider,
  Ka as ContinueCancelModal,
  al as ErrorBoundaryFallback,
  rl as ErrorBoundaryProvider,
  Pr as ErrorPage,
  Xa as FileUploadControl,
  _t as FormErrorText,
  Jr as FormPanel,
  el as FormSubmitButton,
  Nr as Help,
  qt as HelpItem,
  Za as IconMapper,
  xa as KeycloakDataTable,
  nl as KeycloakMasthead,
  Ua as KeycloakProvider,
  sa as KeycloakSelect,
  ba as KeycloakSpinner,
  Wr as KeycloakTextArea,
  va as ListEmptyState,
  Ha as NumberControl,
  ll as OrganizationTable,
  ka as PaginatingTableToolbar,
  Wa as PasswordControl,
  Ut as PasswordInput,
  ea as ScrollForm,
  $r as SelectControl,
  ue as SelectVariant,
  Ja as SwitchControl,
  Ca as TableToolbar,
  Ya as TextAreaControl,
  Qa as TextControl,
  tl as UserProfileFields,
  ja as beerify,
  Xe as createNamedContext,
  Hr as debeerify,
  Ar as generateId,
  Sr as getErrorDescription,
  xr as getErrorMessage,
  $a as getInjectedEnvironment,
  Lt as getNetworkErrorDescription,
  Tr as getNetworkErrorMessage,
  Er as isDefined,
  za as isUserProfileError,
  ne as label,
  Zr as mainPageContentId,
  Ga as setUserProfileServerError,
  _a as useAlerts,
  qa as useEnvironment,
  Wt as useErrorBoundary,
  ya as useFetch,
  Br as useHelp,
  Ze as useRequiredContext,
  Rr as useSetTimeout,
  Nt as useStoredState
};
